module.exports = __webpack_public_path__ + "img/dark-header-3.9fbc5f7e.png";